(function () {
  var COLORS = ['#8A5230', '#241019', '#E0D8CB', '#6B7580', '#5C4650'];
  var lastKnownUnlocked = null; // global state, independent of DOM node identity
  var hasCelebratedForThisUnlock = false;

  function fireConfetti(truck) {
    var rect = truck.getBoundingClientRect();
    if (rect.width === 0 && rect.height === 0) return false; // element not laid out yet, retry next poll

    var originX = rect.left + rect.width / 2;
    var originY = rect.top + rect.height / 2;
    var count = 30;

    for (var i = 0; i < count; i++) {
      var piece = document.createElement('div');
      piece.className = 'fship-confetti-piece';
      piece.innerHTML = '&nbsp;';
      piece.style.background = COLORS[i % COLORS.length];
      piece.style.left = originX + 'px';
      piece.style.top = originY + 'px';

      var angle = Math.random() * Math.PI * 2;
      var distance = 45 + Math.random() * 80;
      var dx = Math.cos(angle) * distance;
      var dy = Math.sin(angle) * distance - 25;
      var rotate = Math.random() * 360;
      var duration = 900 + Math.random() * 500;

      document.body.appendChild(piece);

      piece.animate(
        [
          { transform: 'translate(0, 0) rotate(0deg)', opacity: 1 },
          { transform: 'translate(' + dx + 'px, ' + dy + 'px) rotate(' + rotate + 'deg)', opacity: 0 }
        ],
        { duration: duration, easing: 'cubic-bezier(0.25, 0.7, 0.4, 1)', fill: 'forwards' }
      );

      (function (el, life) {
        setTimeout(function () {
          if (el.parentNode) el.parentNode.removeChild(el);
        }, life + 50);
      })(piece, duration);
    }

    return true; // successfully fired
  }

  function checkBar() {
    var barEl = document.querySelector('.fship');
    if (!barEl) return;

    var isUnlocked = barEl.classList.contains('is-unlocked');

    if (lastKnownUnlocked === null) {
      // Baseline on very first check of this page load.
      lastKnownUnlocked = isUnlocked;
      hasCelebratedForThisUnlock = isUnlocked; // if already unlocked on arrival, don't auto-fire; treat as already celebrated
      return;
    }

    // Reset the "celebrated" flag whenever the cart drops back under the threshold,
    // so the next time it crosses again, it celebrates again.
    if (!isUnlocked) {
      hasCelebratedForThisUnlock = false;
    }

    if (isUnlocked && !hasCelebratedForThisUnlock) {
      var truck = barEl.querySelector('.fship__truck');
      if (truck) {
        var fired = fireConfetti(truck);
        if (fired) {
          hasCelebratedForThisUnlock = true; // only lock in once it actually fired
        }
        // if not fired (zero-size), leave the flag false so the next poll retries
      }
    }

    lastKnownUnlocked = isUnlocked;
  }

  setInterval(checkBar, 400);

  document.addEventListener('DOMContentLoaded', checkBar);
  document.addEventListener('cart:updated', checkBar);
  document.addEventListener('cart:refresh', checkBar);
})();